// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1168":"6c0696bc","2095":"bb313a0d","3889":"bb313a0d","5771":"298c66e8","6767":"bb313a0d"}[chunkId] + ".chunk.css";
};